export default __webpack_public_path__ + "static/media/search.908b56a2.svg";